<script setup lang="ts">
definePageMeta({
  layout: "marketing",
  title: "Studentliv",
})
</script>

<template>
  <UMarketingArticle />
</template>
